<app-navbar></app-navbar>

<!-- slider -->
<section class="about-us-slider swiper-container p-relative">
    <div class="swiper-wrapper">
        <div class="swiper-slide slide-item">
            <img src="assets/img/about/blog/1920x700/banner-8.webp" class="img-fluid full-width" alt="Banner">
            <div class="transform-center">
                <div class="container">
                    <div class="row justify-content-start">
                        <div class="col-lg-7 align-self-start">
                            <div class="right-side-content">
                                <h1 class="text-custom-white fw-600">Hey Burgerians!!!</h1>
                                <h3 class="text-custom-white fw-400">A Burger a Day 
                                    </h3>
                                    <h3 class="text-custom-white fw-400">Keeps the Bland Away 
                                    </h3>
                                <!-- <a routerLink="/menu" class="btn-second btn-submit">Learn More.</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay "></div>
        </div>
        <div class="swiper-slide slide-item" >
            <img src="assets/img/about/blog/1920x700/banner-9.webp"   class="img-fluid full-width" alt="Banner">
            <div class="transform-center">
                <div class="container">
                    <div class="row justify-content-end">
                        <div class="col-lg-8 align-self-end">
                            <div class="right-side-content text-end">
                                <h1 class="text-custom-white fw-600">We are Burgerians, </h1>
                                <h3 class="text-custom-white fw-400">We believe in Burgers</h3>
                                <!-- <a routerLink="/menu" class="btn-second btn-submit">Learn More.</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay "></div>
        </div>
        <div class="swiper-slide slide-item">
            <img src="assets/img/about/blog/1920x700/banner-6.webp"  class="img-fluid full-width" alt="Banner">
            <div class="transform-center">
                <div class="container">
                    <div class="row justify-content-end">
                        <div class="col-lg-7 align-self-end">
                            <div class="right-side-content text-left">
                                <h1 class="text-custom-white fw-600">Ready for a Mouth-Watering Meltdown</h1>
                                <h3 class="text-custom-white fw-400"> </h3>
                                <!-- <a routerLink="/menu" class="btn-second btn-submit">Learn More.</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay "></div>
        </div>
    </div>
    <!-- Add Arrows -->
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
</section>

<section  class="browse-cat u-line section-padding">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-header-left">
                    <h3 class="text-light-black header-title title">Browse by cuisine <span class="fs-14"><a
                                routerLink="/menu"></a></span></h3>
                </div>
            </div>
            <div class="col-12">
                <div class="category-slider swiper-container">
                    <div class="swiper-wrapper">
                        <!-- <div class="swiper-slide">
                            <a routerLink="/menu" class="categories">
                                <div class="icon icon-parent text-custom-white "> <i
                                        class="fas fa-map-marker-alt"></i>
                                </div> <span class="text-light-black cat-name">Brooklyn</span>
                            </a>
                        </div> -->
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'burgers']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/burder11.webp"  class="rounded-circle"
                                        alt="categories">
                                </div> <span class="text-light-black cat-name">Burgers </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'thirst-busters']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/drinks21.webp" class="rounded-circle"
                                        alt="categories">
                                </div> <span class="text-light-black cat-name">Thirst Busters </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'frozen-yoghurt']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/FrozenYoghurt2.webp" class="rounded-circle"
                                    alt="categories">
                            </div> <span class="text-light-black cat-name">Frozen Yoghurt </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'cocktails']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/cocktailimg.webp"  class="rounded-circle"
                                    alt="categories">
                            </div> <span class="text-light-black cat-name">Cocktails </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'tasty-teasers']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/tasty-teasers.webp"  class="rounded-circle"
                                    alt="categories">
                            </div> <span class="text-light-black cat-name">Tasty teasers </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'sides']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/sides1.webp"  class="rounded-circle"
                                    alt="categories">
                            </div> <span class="text-light-black cat-name">Sides </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'Milkshakes']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/milkshakes21.webp"  class="rounded-circle"
                                    alt="categories">
                            </div> <span class="text-light-black cat-name">Milkshakes </span>
                            </a>
                        </div>
                     
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'mocktails']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/moctailimg.webp"   class="rounded-circle"
                                        alt="categories">
                                </div> <span class="text-light-black cat-name">Mocktails </span>
                            </a>
                        </div>
                        <div class="swiper-slide">
                            <a [routerLink]="['/menu', 'junior']" class="categories">
                                <div class="icon text-custom-white  ">
                                    <img src="assets/img/restaurants/125x125/burder11.webp"  class="rounded-circle"
                                        alt="categories">
                                </div> <span class="text-light-black cat-name">Junior Nibblers</span>
                            </a>
                        </div>
                    </div>
                    <!-- Add Arrows -->
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="aboutus section-padding">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="history-title mb-md-40">
                    <p class="text-light-green">LA BURGERS and Shakes</p>

                    <h2 class="text-light-black"> <span class="text-light-green">
                        In Burgers We Trust Welcome to the Legendary Land of Burgers</span></h2>
                    <p class="text-light-white">For too long, burger lovers have wandered the fast-food land, searching for a burger that satisfies the soul. Fear not, for a new ethos has risen - Burgerism! Join us in our grand mission to bring the bold and flavorful essence of Los Angeles to the heart of Australia. And what better way to elevate this extraordinary burger experience than with our selection of refreshing beverages.</p>
                    <h3 class="text-light-green">Menu</h3>
        <p class="text-light-white">Our menu has a variety of burger options to satisfy any taste. Enjoy the timeless classic cheeseburger with a juicy beef patty and melted cheese. You have an option of adding crispy fries with every Burger to enhance your taste buds. We also offer a selection of sides and drinks to complete your meal. Join us at LA Burgers and savor the flavors that make every bite a Burgerian delight.</p>

                </div>
            </div>
            <div class="col-lg-6">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="histry-img mb-xs-20">
                            <img src="assets/img/about/blog/255x200/melted-cheese-burger.webp"  class="img-fluid full-width" alt="Histry">
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="histry-img mb-xl-20">
                            <img src="assets/img/about/blog/255x200/delicious-burgers-studio.webp"  class="img-fluid full-width" alt="Histry">
                        </div>
                        <div class="histry-img">
                            <img src="assets/img/about/blog/255x200/delicious-burgers-studio1.webp"  class="img-fluid full-width" alt="Histry">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="ex-collection section-padding">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-header-left">
                    <h3 class="text-light-black header-title title">Explore our collections</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="ex-collection-box mb-xl-20">
                    <img src="assets/img/restaurants/540x300/collection-1.jpg"  class="img-fluid full-width" alt="image">
                    <!-- <div class="category-type overlay padding-15"> <a routerLink="/menu" class="category-btn">Top
                            rated</a>
                    </div> -->
                </div>
            </div>
            <div class="col-md-6">
                <div class="ex-collection-box mb-xl-20">
                    <img src="assets/img/restaurants/540x300/collection-2.jpg"  class="img-fluid full-width" alt="image">
                    <!-- <div class="category-type overlay padding-15"> <a routerLink="/menu" class="category-btn">Top
                            rated</a>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-9 col-md-8">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Double-cheese.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                               
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title">
                                        <a [routerLink]="['/menu']" class="text-light-black ">
                                            Double Cheese Delight</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-yellow">
                                            3.1
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">American, Fast Food</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$18.50</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/004-leaf.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/006-chili.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg"   alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg"  alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Smokehouse Special.webp"   class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                              
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu']" class="text-light-black ">
                                        Smokehouse Special</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-red">
                                            2.1
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Breakfast, Lunch & Dinner</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$15.50

                                        </span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/007-chili-1.svg" alt="tag" >
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/004-leaf.svg" alt="tag" >
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg" alt="tag" >
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Spicy_Swagger.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                              
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu']" class="text-light-black "> Spicy Swagger</a></h6>
                                    <!-- <div class="tags"> <span class="text-custom-white rectangle-tag bg-green">
                                            4.5
                                        </span>
                                    </div> -->
                                </div>
                                <p class="text-light-white">Pizzas, Fast Food</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$14.50

                                        </span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg" alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/004-leaf.svg" alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/LA_Classic.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                               
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu']" class="text-light-black ">
                                        L.A Classic  </a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-green">
                                            4.5
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Desserts, Beverages</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$14.50</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg"   alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg"  alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Yankee_Crisp.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                               
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu']" class="text-light-black "> Yankee Crisp</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-red">
                                            2.1
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Continental & Mexican</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$15.00</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Wild_West_Whine.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                           
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu']" class="text-light-black ">
                                        Wild West Whine</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-green">
                                            4.5
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Indian, Chinese, Tandoor</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$17.50</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg"   alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4">
                <div class="large-product-box mb-xl-20 p-relative">
                    <img src="assets/img/restaurants/255x587/Banner-12.jpg"  class="img-fluid full-width" alt="image">
                    <div class="category-type overlay padding-15">
                        <button class="category-btn">Most popular</button> <a [routerLink]="['/menu']"
                            class="btn-first white-btn text-light-black fw-600 full-width">See all</a>
                    </div>
                </div>
            </div>
           
        </div>
        <app-advertisementbanner></app-advertisementbanner>
        <div class="row">
            <div class="col-lg-3 col-md-4">
                <div class="large-product-box mb-xl-20 p-relative">
                    <img src="assets/img/restaurants/255x587/Banner-1.jpg"  class="img-fluid full-width" alt="image">
                    <div class="category-type overlay padding-15">
                        <button class="category-btn">Most popular </button> <a [routerLink]="['/menu']"
                            class="btn-first white-btn text-light-black fw-600 full-width">See all</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 col-md-8">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Hot_Wooly.webp"   class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                               
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu', 'tasty-teasers']" class="text-light-black ">
                                        Hot Wooly</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-yellow">
                                            3.1
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">American, Fast Food</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$
                                            17.50</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/004-leaf.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/006-chili.svg" alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg"   alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Angry_Bird.webp"   class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                              
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu', 'tasty-teasers']" class="text-light-black ">
                                        Angry Bird</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-red">
                                            2.1
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Breakfast, Lunch & Dinner</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$
                                            17.50</span>
                                    </div>
                                    <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/007-chili-1.svg" alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/004-leaf.svg" alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg" alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Green_Goddess_Gastronomy.webp" class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                              
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu', 'tasty-teasers']" class="text-light-black "> Green Goddess Gastronomy</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-green">
                                            4.5
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Pizzas, Fast Food</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$
                                            16.50</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg" alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/004-leaf.svg" alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Vegan_Verve.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                             
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu', 'tasty-teasers']" class="text-light-black ">
                                        Vegan Verve</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-green">
                                            4.5
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Desserts, Beverages</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">$
                                            17.00</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg" alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg"  alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Tiny_ott_Cheeseburger.webp" class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                             
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu', 'tasty-teasers']" class="text-light-black ">Tiny Tott Cheeseburger</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-red">
                                            2.1
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Continental & Mexican</p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">--</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="product-box mb-xl-20">
                            <div class="product-img">
                                <a [routerLink]="['/menu']">
                                    <img src="assets/img/restaurants/255x150/Crunchy_cheese_Stack.webp"  class="img-fluid full-width"
                                        alt="product-img">
                                </a>
                             
                            </div>
                            <div class="product-caption">
                                <div class="title-box">
                                    <h6 class="product-title"><a [routerLink]="['/menu', 'tasty-teasers']"
                                            class="text-light-black ">Crunchy cheese Stack</a></h6>
                                    <div class="tags"> <span class="text-custom-white rectangle-tag bg-green">
                                            4.5
                                        </span>
                                    </div>
                                </div>
                                <p class="text-light-white">Indian, Chinese, Tandoor </p>
                                <div class="product-details">
                                    <div class="price-time"> <span class="text-light-black time">30-40 min</span>
                                        <span class="text-light-white price">--</span>
                                    </div>
                                     <!-- <div class="rating"> <span>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                            <i class="fas fa-star text-yellow"></i>
                                        </span>
                                        <span class="text-light-white text-right">4225 ratings</span>
                                    </div> -->
                                </div>
                                <div class="product-footer"> <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/005-chef.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/008-protein.svg"  alt="tag">
                                    </span>
                                    <span class="text-custom-white square-tag">
                                        <img src="assets/img/svg/009-lemon.svg"  alt="tag">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
       
      
    </div>
</section>


<app-footer1></app-footer1>